<template>
    <OrderTMStatusChip :value="params.value" />
</template>
<script>
import OrderTMStatusChip from './OrderTMStatusChip';

export default {
    name: 'OrderStatusChipAgGrid',
    components: {
        OrderTMStatusChip,
    },
    props: {
        params: {
            type: Object,
            required: true,
        },
    },
};
</script>
